import { create } from "zustand";
import type { ListFilterValues } from "@/shared/components/common/ListFilterPopover";
import type { ContentCreatorListRow } from "@/features/contentCreators/types/contentCreator.types";

const initialContentCreatorListFilters: ListFilterValues = {
  accountStatus: "",
};

export interface ContentCreatorsSuccessNotification {
  message: string;
  count?: number;
}

export interface ContentCreatorsListState {
  list: ContentCreatorListRow[];
  successNotification: ContentCreatorsSuccessNotification | null;
  page: number;
  totalCount: number;
  listFilterValues: ListFilterValues;
  searchQuery: string;

  setPage: (page: number) => void;
  setTotalCount: (count: number) => void;
  setList: (list: ContentCreatorListRow[]) => void;
  setListFilterValues: (values: ListFilterValues) => void;
  /** Also resets the page to 1. */
  setSearchQuery: (query: string) => void;
  setSuccessNotification: (
    notification: ContentCreatorsSuccessNotification | null,
  ) => void;
  dismissSuccessNotification: () => void;
  removeContentCreator: (id: string) => void;
  updateContentCreator: (
    id: string,
    row: Omit<ContentCreatorListRow, "id">,
  ) => void;
}

export const useContentCreatorsListStore = create<ContentCreatorsListState>(
  (set) => ({
    list: [],
    successNotification: null,
    page: 1,
    totalCount: 0,
    listFilterValues: initialContentCreatorListFilters,
    searchQuery: "",

    setPage: (page) => set({ page }),
    setTotalCount: (totalCount) => set({ totalCount }),
    setList: (list) => set({ list }),
    setListFilterValues: (listFilterValues) => set({ listFilterValues }),
    setSearchQuery: (searchQuery) => set({ searchQuery, page: 1 }),
    setSuccessNotification: (successNotification) =>
      set({ successNotification }),
    dismissSuccessNotification: () => set({ successNotification: null }),
    removeContentCreator: (id) =>
      set((s) => ({ list: s.list.filter((r) => r.id !== id) })),
    updateContentCreator: (id, row) =>
      set((s) => ({
        list: s.list.map((r) => (r.id === id ? { ...row, id } : r)),
      })),
  }),
);
